class HazardsTranslator {
  translateHazards (hazardResponse) {
    var translated = {
      hazards: [],
      locationHazards: []
    };

    if (hazardResponse == null) return translated;

    if ((hazardResponse.A || null) !== null) {
      translated.hazards = hazardResponse.A.map(x => this.translateHazard(x));
    }

    if ((hazardResponse.B || null) !== null) {
      translated.locationHazards = hazardResponse.B.map(x => this.translateLocationHazard(x));
    }

    return translated;
  }

  translateWorkHazards (hazardResponse) {
    var translated = {
      hazards: [],
      locationHazards: []
    };

    if (hazardResponse == null) return translated;

    if ((hazardResponse.A || null) !== null) {
      translated.hazards = hazardResponse.A.map(x => this.translateWorkHazard(x));
    }

    if ((hazardResponse.B || null) !== null) {
      translated.locationHazards = hazardResponse.B.map(x => this.translateLocationWorkHazard(x));
    }

    return translated;
  }

  translateLocationHazard (location) {
    if ((location || null) === null) return null;

    return {
      name: location.A,
      number: location.B,
      hazards: location.C.map(x => this.translateHazard(x))
    };
  }

  translateLocationWorkHazard (location) {
    if ((location || null) === null) return null;

    return {
      name: location.A,
      number: location.B,
      hazards: location.C.map(x => this.translateWorkHazard(x))
    };
  }

  translateHazard (result) {
    return {
      number: result.A,
      classification: result.B,
      premiumBasis: result.C,
      exposure: result.D,
      premisesRate: result.E,
      premisesPremium: result.F,
      productsRate: result.G,
      productsPremium: result.H,
      otherPremium: result.I,
      totalPremium: result.J
      // classCode: result.K,
    };
  }

  translateWorkHazard (hazard) {
    return {
      categoryDuties: hazard.A,
      fullTimeEmployees: hazard.B,
      partTimeEmployees: hazard.C,
      naics: hazard.D,
      estimatedPayroll: hazard.E,
      premium: hazard.F,
      classCode: hazard.G,
      // sic: hazard.H,
      rate: hazard.I
    };
  }
}

var x = new HazardsTranslator();
export default x;
